import styled, { StyledFunction } from "styled-components"

export const TableHeaderWrapper = styled.table`
    & > thead > tr > th {
        color: white;
        overflow: hidden;
        padding: 5px 0px 5px 3px !important;
    }
`;

export const TableRowWrapper = styled.tr`
    & > td {
        padding: 3px 0px 3px 3px !important;
        vertical-align: middle !important;
    }
`;

export const SummaryTitles = styled.tr`
    & > td {
        background-color: #00004c;
        color: white;
        font-size: 9px;
    }
`;

export const SummaryValues = styled.tr`
    & > td {
        font-size: 12px;
    }
`;

interface IGridWrapperProps {
    height?: string
}

export const GridWrapper = styled.div<IGridWrapperProps>`
    height: ${p => p.height ? p.height : '78vh'};
    
    font-family: Roboto;

    .ag-header {
        background-color: #133366;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row-selected > .ag-cell {
        background-color: yellow !important;
        color: black;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .center-list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        color: #fff;
    }

    .center-list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
        font-size: 12px;
        justify-content: center;
        display: flex;
    }

    .customHeaderLabel {
        text-align: center;
    }

    .ag-date-filter > .ag-text-field-input-wrapper > .ag-text-field-input {
        padding: 3px;
        border-radius: 4px;
        border: 1px solid darkgrey !important;
        font-family: Roboto;
    }

    @media (max-width: 1920px) {
        font-size: 12px;
    }

    .ag-filter-select {
        font-family: Roboto;
    }
    .ag-standard-button.ag-filter-apply-panel-button {
        // color: #fff;
        padding: 3px 6px;
        border: 1px solid transparent;
        border-radius: 4px;
        // background-color: #337ab7;
        border-color: #2e6da4;
        font-size: 12px;
        font-family: Roboto;
    }
`;

export const HeaderWrapper = styled.div`
    .billing-header {
        font-size: 28px;
        font-weight: 500;
        margin-top: 5px;
        margin-bottom: 20px;
    }

    .btn-bg.active {
        color: white;
        background-color: #286090 !important;
    }

    .btn-nocolor {
        color: black; /* Set the desired text color */
        background-color: transparent; /* Set the background color to transparent */
        border-color: #D3D3D3; /* Set the border color to the desired color */
    }

    @media screen and (max-width: 1900px) {
        // .well {
        //     font-size: 12px;
        // }

        .btn, .form-control {
            font-size: 12px;
        }
    }

    @media screen and (max-width: 1750px) {
        // .well {
        //     font-size: 10px;
        // }

        .btn, .form-control {
            font-size: 10px;
        }

        .form-control {
            padding: 4px 10px;
            height: 28px;
            line-height: 28px;
        }
    }

    @media screen and (max-width: 1530px) {
        .well {
            font-size: 10px;
        }

        .btn {
            font-size: 10px;
        }

        .form-control {
            padding: 4px 10px;
            height: 28px;
            line-height: 28px;
            font-size: 10px;
        }
    }

    @media screen and (max-width: 1280px) {
        .well {
            font-size: 8px;
        }

        .btn {
            font-size: 8px;
        }

        .btn {
            padding: 3px 6px;
        }

        .form-control {
            padding: 3px 6px;
            height: 22px;
            line-height: 22px;
            font-size: 10px;
        }
    }
`;

